module.exports = __webpack_public_path__ + "static/media/button_cert_zh.c060d44a.png";